import React from 'react';
import DetailPanel from './../core/detail';
import BidService from './../../../service/bid';
import BidDetailViewPanel from './view';
import SplashContactingServerPanel from './../core/splash-contacting-server';
import UnableToLoadTargetPanel from './../core/unable-to-load-target';
import { connect } from 'react-redux';
import mapStateToProps from './../../../store/map/auth-token';
import mapDispatchToProps from './../../../store/map/on-logout';
import { EXCHANGE_TYPE_ONLINE } from './../../prompt/core/enum/exchange-type';

class _BidDetailPanel extends DetailPanel 
{
    constructor(parms)
    {
        super(parms);

        this.loadData = this.loadData.bind(this);
        this.getLoadDataRequest = this.getLoadDataRequest.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getLoadedDataDetailUi = this.getLoadedDataDetailUi.bind(this);
        this.onAcceptBid = this.onAcceptBid.bind(this);
        this.onRejectBid = this.onRejectBid.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.onAcceptBidResponse = this.onAcceptBidResponse.bind(this);
        this.onLoadDataError = this.onLoadDataError.bind(this);
        this.getDefaultState = this.getDefaultState.bind(this);
        this.getUnLoadedDataDetailUi = this.getUnLoadedDataDetailUi.bind(this);
        this.onContactingPayServer = this.onContactingPayServer.bind(this);
        this.onContactingPayServerDone = this.onContactingPayServerDone.bind(this);

    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }


    onLoadDataResponse(response)
    {
        if(response.exchangeId)
        {
            this.sendUserTo(`/exchange/${response.exchangeId}`);
        }
        else 
        {
            super.onLoadDataResponse(response);
        }
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    loadData(inputObj)
    {
        super.loadData(inputObj);
        BidService.getDetails({
            request: this.getLoadDataRequest(inputObj),
            onResponse: this.onLoadDataResponse,
            onError: this.onLoadDataError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getDefaultState()
    {
        const baseState = super.getDefaultState();
        return {
            ...baseState,
            unableToLoadTarget: false,
            contactingPayServer: false
        };
    }

    /* istanbul ignore next */
    onContactingPayServer()
    {
        let nextState = this.state;
        nextState.contactingPayServer = true;
        this.setState(nextState);
    }

    /* istanbul ignore next */
    onContactingPayServerDone()
    {
        let nextState = this.state;
        nextState.contactingPayServer = false;
        this.setState(nextState);
    }

    onLoadDataError(error)
    {
        if(error.response && error.response.error && error.response.error === 'Unable to load bid details')
        {
            const nextState = {
                ...this.state,
                contactingServer: false,
                data: undefined,
                message: '',
                unableToLoadTarget: true,
            };
            this.setState(nextState);
        }
        else
        {
            super.onLoadDataError(error);
        }
    }

    getLoadDataRequest(inputObj)
    {
        return {
            bidId: inputObj.bidId
        };
    }

    componentDidMount()
    {
        const bidId = this.props.bidId;
        this.loadData({
            bidId,
        });
    }

    getUnLoadedDataDetailUi()
    {
        return this.state.unableToLoadTarget ? <UnableToLoadTargetPanel title="Bid" /> : super.getUnLoadedDataDetailUi();
    }

    getLoadedDataDetailUi()
    {
        const bidderIsReceiver = this.state.data.targetType === 'offer' ? true : false;
        return (
            <section>
                {
                    /* istanbul ignore next */
                    this.state.contactingPayServer &&
                        <SplashContactingServerPanel />
                }
                <BidDetailViewPanel 
                    bidderIsReceiver={bidderIsReceiver} 
                    data={this.state.data} 
                    onRejectBid={this.onRejectBid} 
                    onAcceptBid={this.onAcceptBid}  
                    onContactingServer={this.onContactingPayServer}
                    onContactingServerResponse={this.onContactingPayServerDone}
                    setPayClientSecret={this.props.setPayClientSecret}
                />
            </section>
        );
    }

    onAcceptBidResponse(response)
    {
        this.sendUserTo(`/exchange/${response.exchangeId}`);
    }

    onAcceptBid()
    {
        super.loadData({ });
        /* istanbul ignore next */
        if(this.state.data.exchangeMethod === EXCHANGE_TYPE_ONLINE)
        {
            throw new Error('setup BidDetail.onAcceptBid()');
        }
        else
        {
            BidService.setApprovalState({
                request: {
                    bidId: this.props.bidId,
                    accepted: true,
                    rejected: false,
                },
                onResponse: this.onAcceptBidResponse,
                onError: this.onLoadDataError,
                authToken: this.props.authToken,
                onAuthError: this.onAuthError,
                onFatalError: this.onFatalError,
                onNetworkOffline: this.onNetworkOffline
            });
        }
    }

    onRejectBid()
    {
        super.loadData({ });
        BidService.setApprovalState({
            request: {
                bidId: this.props.bidId,
                accepted: false,
                rejected: true,
            },
            onResponse: this.onLoadDataResponse,
            onError: this.onLoadDataError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }
}

const BidDetailPanel = connect(mapStateToProps, mapDispatchToProps)(_BidDetailPanel);
export default BidDetailPanel;
